import {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {AccountRecovery} from '../../../../reducers/modals/actions';
import ModalsLib from '../../../../lib/modals';
import FormInput from '../../../components/form-input';
import BlueButton from '../../../components/blue-button';

export default ({data}) => {
    const [type, setType] = useState('email'),
          [value, setValue] = useState('');

    const dispatch = useDispatch();

    useEffect(() => {
        setValue('');
    }, [type]);

    return (
        <>
            <div className="modal-header">
                <div className="modal-header-left">
                    <div className="title">Username Recovery</div>
                    <div className="descriptions">Specify the phone number or email address that is linked to your account and we will send you the username.</div>
                </div>
                <div className="close" onClick={e => ModalsLib.close()}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <div className="modal-body">
                <div className="recovery-methods">
                    <div className={`option ${type === 'email' ? 'active' : ''}`} onClick={e => {
                        setValue('');
                        setType('email')
                    }}>Email</div>
                    <div className={`option ${type === 'phone' ? 'active' : ''}`} onClick={e => {
                        setType('phone')
                        setValue('');
                    }}>Phone</div>
                </div>

                <div className="form-group">
                    {type === 'email' ? (
                        <FormInput
                            name="email"
                            type={'text'}
                            label={null}
                            placeholder={'Email'}
                            defaultValue={value}
                            validators={[
                                (v) => {
                                    const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                                    return regex.test(v);
                                }
                            ]}
                            onChange={({value, validator}) => setValue(value)} />
                    ) : (
                        <FormInput
                            name="phone"
                            type={'tel'}
                            label={null}
                            placeholder={'(198) 765 43-21'}
                            defaultValue={value}
                            isPhone={true}
                            validators={[
                                (v) => {
                                    v = v.replace(/[^0-9]/gi, '');
                                    return v.length === 10;
                                }
                            ]}
                            onChange={({value, validator}) => setValue(value.replace(/[^0-9]/gi, ''))} />
                    )}
                </div>

                {data.error && (
                    <div class="modal-message warning">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 7.75V13" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M12 16.2V16.2999" stroke="#DA6C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                        <span dangerouslySetInnerHTML={{__html: data.error}}></span>
                    </div>
                )}
            </div>
            <div className="modal-footer" style={{flexDirection: 'row'}}>
                <BlueButton active={data.button} onClick={e => {
                    dispatch(AccountRecovery.sendUsername({type, value}));
                }}>
                    Send
                </BlueButton>
                <div className="button back" onClick={e => dispatch(AccountRecovery.stage('choose'))}>
                    Back
                </div>
            </div>
        </>
    )
}